if (typeof G === 'undefined') G = {};
G.UI = G.UI || {};

(function() {

G.UI.getSize           = getSize;
G.UI.hasUIComponent    = hasUIComponent;
G.UI.addUIComponent    = addUIComponent;
G.UI.createUIComponent = createUIComponent;
G.UI.cloneUIComponent  = cloneUIComponent;

return;

function getSize(object) {
    var width, height;
    if (hasUIComponent(object)) {
        var uiComponent = object.customComponents.ui;
        width  = uiComponent.desiredSize.x;
        height = uiComponent.desiredSize.y;
    } else {
        width  = object.width;
        height = object.height;
    }
    return {
        width:  width,
        height: height
    };
}

function hasUIComponent(object) {
    return Boolean(object.customComponents && object.customComponents.ui);
}

function addUIComponent(target, uiComponent) {
    target.customComponents = target.customComponents || {};
    target.customComponents.ui = uiComponent;
}

/**
 * @param uiElementType {G.UI.ElementType}
 * @returns uiComponent {G.UI.UIComponent}
 */
function createUIComponent(
    uiElementType,
    parentWidth,
    parentHeight,
    optLayoutData,
    optScaleX,
    optScaleY
) {

    // imports

    var defined = G.Utils.defined;
    var AnchoredLayoutComponent = G.UI.AnchoredLayoutComponent;
    var Vector2 = G.Math.Vector2;

    //

    var scaleX = defined(optScaleX, 1);
    var scaleY = defined(optScaleY, 1);
    var layoutData = optLayoutData || {};
    
    var pivotData = layoutData.pivot || [0, 0];
    var pivot = new Vector2(pivotData[0], pivotData[1]);

    var layout = new AnchoredLayoutComponent();
    fillLayoutFromData(layout, layoutData, pivotData, scaleX, scaleY);
    var desiredSize = layout.getLocalSize(parentWidth, parentHeight);

    var sizeAfterLastResize = new Vector2(NaN, NaN);

    var constrains = getConstrains(layoutData.constrains || {}, scaleX, scaleY);

    var uiComponent = {
        type:                uiElementType,
        desiredSize:         desiredSize,
        sizeAfterLastResize: sizeAfterLastResize,
        anchoredLayout:      layout,
        layoutConstrains:    constrains,
        pivot:               pivot
    };

    return uiComponent;
}

function cloneUIComponent(other, type) {

    var uiComponent = {
        type:                type,
        desiredSize:         other.desiredSize.clone(),
        sizeAfterLastResize: other.sizeAfterLastResize.clone(),
        anchoredLayout:      other.anchoredLayout.clone(),
        layoutConstrains:    cloneConstrains(other.layoutConstrains),
        pivot:               other.pivot.clone()
    };

    return uiComponent;
}

//

function fillLayoutFromData(layout, layoutData, pivotData, scaleX, scaleY) {

    var offsets = layoutData.offsets || [0, 0, 0, 0];
    layout.cornerOffsets.fromLeft   = offsets[0] * scaleX;
    layout.cornerOffsets.fromTop    = offsets[1] * scaleY;
    layout.cornerOffsets.fromRight  = -offsets[2] * scaleX;
    layout.cornerOffsets.fromBottom = -offsets[3] * scaleY;

    if (layoutData.anchorsManualEditHelper) {
        var data = layoutData.anchorsManualEditHelper;
        var imaginaryPivotData = data.imaginaryPivot || pivotData;
        layout.calculateAnchorsFor(
            data.imaginaryParentSize[0],
            data.imaginaryParentSize[1],
            data.imaginaryPosition[0] - imaginaryPivotData[0] * data.imaginarySize[0],
            data.imaginaryPosition[1] - imaginaryPivotData[1] * data.imaginarySize[1],
            data.imaginarySize[0],
            data.imaginarySize[1]
        );
    } else {
        if (layoutData.anchors) {
            layout.anchors.start.set(layoutData.anchors[0], layoutData.anchors[1]);
            layout.anchors.end.set(layoutData.anchors[2], layoutData.anchors[3]);
        }
    }
}

function getConstrains(constrainsData, scaleX, scaleY) {

    var defined = G.Utils.defined;

    var center = defined(constrainsData.constrainCenter, [0.5, 0.5]);
    return {
        widthMin: scaled(constrainsData.widthMin, scaleX),
        widthMax: scaled(constrainsData.widthMax, scaleX),
        heightMin: scaled(constrainsData.heightMin, scaleY),
        heightMax: scaled(constrainsData.heightMax, scaleY),
        preserveAspectRatio: defined(constrainsData.preserveAspectRatio, false),
        aspectRatioMin: defined(constrainsData.aspectRatioMin, null),
        aspectRatioMax: defined(constrainsData.aspectRatioMax, null),
        constrainAnchorX: center[0],
        constrainAnchorY: center[1]
    };

    function scaled(value, scale) {
        return (value === undefined) ? null : value * scale;
    }
}

function cloneConstrains(other) {
    return {
        widthMin:            other.widthMin,
        widthMax:            other.widthMax,
        heightMin:           other.heightMin,
        heightMax:           other.heightMax,
        preserveAspectRatio: other.preserveAspectRatio,
        aspectRatioMin:      other.aspectRatioMin,
        aspectRatioMax:      other.aspectRatioMax,
        constrainAnchorX:    other.constrainAnchorX,
        constrainAnchorY:    other.constrainAnchorY
    };
}

}());
